import { observer } from "mobx-react-lite";
import * as React from "react";
import type { HeadingProps } from "@chakra-ui/react";
import { Heading } from "@chakra-ui/react";

export type Presets = "preset4" | "preset5" | "preset6" | "preset7" | "preset8" | "preset9";
export interface IPropsTitle extends HeadingProps {
	preset: Presets;
}

/**
 ** fontSizes m = mobile | d = desktop

 * preset4 = m: 28px d: 40px |
 * preset5 = m: 20px d: 28px |
 * preset6 = m: 24px d: 32px |
 * preset7 = m: 16px d: 18px |
 * preset8 = m: 32px d: 48px |
 * preset9 = m: 32px d: 56px
 */

export const Title: React.FC<IPropsTitle> = observer((props) => {
	const { children, preset, ...headingProps } = props;

	const selectedTitleSize = React.useMemo(
		() => {
			switch (preset) {
				case "preset9":
					return "exll";
				case "preset8":
					return "xl";
				case "preset7":
					return "lg";
				case "preset6":
					return "md";
				case "preset5":
					return "sm";
				case "preset4":
					return "exl";
			}
		},
		[preset],
	);

	return (
		<Heading
			size={selectedTitleSize}
			{...headingProps}
		>
			{children}
		</Heading>
	);
});
